module.exports = __webpack_public_path__ + "img/thread.6acd4271.png";